import {
  ArchiveIcon,
  GitMergeIcon,
  GitMergeQueueIcon,
  GitPullRequestClosedIcon,
  GitPullRequestDraftIcon,
  GitPullRequestIcon,
  IssueClosedIcon,
  IssueOpenedIcon,
  SkipIcon,
} from '@primer/octicons-react'

export const VALUES = {
  issueHierarchyItemChildrenFetchPageSize: 25,
  issueItemLabelFetchPageSize: 10,
  maxListSize: 100,
  copilotDisplayName: 'Copilot',
  ghostUserLogin: 'ghost',
  ghostUserAvatarUrl: '/ghost.png',
}

export const ICONS_VALUES = {
  issueIcons: {
    OPEN: {
      color: 'var(--fgColor-open)',
      icon: IssueOpenedIcon,
      description: 'Status: Open.',
    },
    CLOSED: {
      color: 'var(--fgColor-done)',
      icon: IssueClosedIcon,
      description: 'Status: Closed (completed).',
    },
    // same as Closed
    COMPLETED: {
      color: 'var(--fgColor-done)',
      icon: IssueClosedIcon,
      description: 'Status: Closed (completed).',
    },
    NOT_PLANNED: {
      color: 'var(--fgColor-muted)',
      icon: SkipIcon,
      description: 'Status: Not planned (skipped).',
    },
    DUPLICATE: {
      color: 'var(--fgColor-muted)',
      icon: SkipIcon,
      description: 'Status: Duplicate of an existing item.',
    },
  },
  pullRequestIcons: {
    MERGED: {
      color: 'var(--fgColor-done)',
      icon: GitMergeIcon,
      description: 'Status: Merged (completed).',
    },
    IN_MERGE_QUEUE: {
      color: 'var(--fgColor-attention)',
      icon: GitMergeQueueIcon,
      description: 'Status: In merge queue.',
    },
    OPEN: {
      color: 'var(--fgColor-open)',
      icon: GitPullRequestIcon,
      description: 'Status: Open (in progress).',
    },
    CLOSED: {
      color: 'var(--fgColor-closed)',
      icon: GitPullRequestClosedIcon,
      description: 'Status: Closed (abandoned).',
    },
    DRAFT: {
      color: 'var(--fgColor-draft)',
      icon: GitPullRequestDraftIcon,
      description: 'Status: Draft (not ready).',
    },
    ARCHIVED: {
      color: 'var(--fgColor-muted)',
      icon: ArchiveIcon,
      description: 'Status: Archived (abandoned).',
    },
  },
}
